import { gql } from '@apollo/client';

export const PENDING_GENERAL_DL_VERIFICATIONS = gql`
  query PendingGeneralDLVerifications {
    pendingGeneralDLVerifications {
      id
      userId
      frontDriverLicenseUrl
      backDriverLicenseUrl
      frontImageUrl
      backImageUrl
      expirationDate
      birthDate
      legalFirstName
      legalMiddleName
      legalLastName
      isValid
      isVerifiedByAdmin
      submittedAt
      canBeAdditionalDriver
      licenceNumberLast4
      licenceNumber
      issueDate
      issuingRegion
      submittedBrandSite
      submittedVia
      recheckRequestedAt
      recheckNote
      user {
        id
        email
        firstName
        lastName
        displayName
      }
    }
  }
`;

export const REVIEW_GENERAL_DL_VERIFICATION = gql`
  mutation ReviewGeneralDLVerification($input: ReviewGeneralDLVerificationInput!) {
    reviewGeneralDLVerification(input: $input) {
      id
      userId
      isVerifiedByAdmin
      isValid
      expirationDate
      birthDate
      legalFirstName
      legalMiddleName
      legalLastName
      canBeAdditionalDriver
      licenceNumberLast4
      licenceNumber
      issueDate
      issuingRegion
      submittedBrandSite
      submittedVia
      recheckRequestedAt
      recheckNote
    }
  }
`;
